/**
 * What the rest of the cockpit needs to know about the KI-Assistent: whether
 * the drawer is open (the ChatBubble opens it), whether an answer is
 * streaming (the ChatBubble shows it while the drawer is closed) and which
 * conversation is open (the source dialog closes on a switch). The
 * conversation state itself lives in the shared assistant's useAssistant.
 */

import { create } from 'zustand';

/** The conversations page; the drawer and the launcher stay away from it. */
export const ASSISTANT_PAGE = '/cockpit/sessions';

interface AssistantUiState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  streaming: boolean;
  setStreaming: (streaming: boolean) => void;
  sessionId: string | null;
  setSessionId: (sessionId: string | null) => void;
}

export const useAssistantUi = create<AssistantUiState>()((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
  streaming: false,
  setStreaming: (streaming) => set({ streaming }),
  sessionId: null,
  setSessionId: (sessionId) => set({ sessionId }),
}));
